import React, { Component } from "react";
import "antd/dist/antd.css";
import Login from "./Login";
import {
  Form,
  Input,
  Popover,
  Button,
  Row,
  Col,
  Checkbox,
  message,
  Modal,
  Divider,
  Drawer,
  notification,
  Select,
} from "antd";
import Amplify, { Auth } from "aws-amplify";
import ProfileCompletionModal from "../common/ProfileCompletionModal";
import AwsConfig from "../config/AwsConfig";
import AppConfig from "../config/AppConfig";
import { withRouter, Link } from "react-router-dom";
import { getDetails, noAuthadd, noAuthlist, usersList } from "../api/Apis";
import NumberFormat from "react-number-format";
import { withAppContext } from "../store/contextStore";
import SignupModal from "../common/SignupModal";
import logo from "../images/budhaLogo.png";
import { CloseOutlined } from "@ant-design/icons";
import SigninWithGoogle from "./SigninWithGoogle";
import SigninWithFacebook from "./SigninWithFacebook";

Amplify.configure(AwsConfig);

const { Option } = Select;

export class RegisterForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetails:           { userProfile: "B" },
      errors:                "",
      loading:               false,
      validatePassword:      "",
      signUpResponseData:    "",
      visible:               false,
      password:              "",
      email:                 "",
      loginPopupTrue:        false,
      visibleTerms:          false,
      allUsersList:          [],
      referedById:           "",
      referedByName:         "",
      userProfile:           "",
      accountCreateWithEmail: false,
      showProfileModal:      false,
      loggedInUserData:      null,
      smsOptIn:              false,   // ← NEW: explicit SMS consent
    };
  }

  componentDidMount() {
    this.getAllUsers();
    const params       = new URLSearchParams(window.location.search);
    const refAgentId   = params.get("ref");
    const refType      = params.get("type");
    const refAgentName = params.get("agentName") || "";

    if (refAgentId) {
      sessionStorage.setItem("inviteRef", JSON.stringify({ agentId: refAgentId, type: refType || "AG" }));
      if (refAgentName) {
        this.setState({ referedById: refAgentId, referedByName: refAgentName });
      } else {
        this.pendingRefId = refAgentId;
      }
    } else {
      try {
        const stored = JSON.parse(sessionStorage.getItem("inviteRef") || "null");
        if (stored?.agentId) this.pendingRefId = stored.agentId;
      } catch(e) {}
    }
  }

  getAllUsers = async () => {
    try {
      const usersListData = await noAuthlist("getUsers");
      const finalUsersList = usersListData.data.map(user => ({
        value: user.id,
        label: user.firstName + " " + user.lastName,
      }));
      if (usersListData.success) {
        this.setState({ allUsersList: finalUsersList });
        if (this.pendingRefId) {
          const match = finalUsersList.find(u => u.value === this.pendingRefId);
          this.setState({
            referedById:   match?.value || this.pendingRefId,
            referedByName: match?.label || "",
          });
          this.pendingRefId = null;
        }
      } else {
        notification["error"]({ message: usersListData.data.message });
      }
    } catch (error) {
      notification["error"]({ message: error.message });
    }
  };

  showDrawer = () => this.setState({ visibleTerms: true });
  onClose    = () => this.setState({ visibleTerms: false });

  handleOnChange = (element, value) => {
    if (element === "password") {
      const valid = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/.test(value);
      this.setState({ validatePassword: valid ? true : value === "" ? "" : false });
    }
    if (element === "mlsId") {
      this.setState({ userDetails: { ...this.state.userDetails, [element]: value.toUpperCase() } });
    } else if (element !== "email") {
      this.setState({ userDetails: { ...this.state.userDetails, [element]: value } });
    } else {
      this.setState({ userDetails: { ...this.state.userDetails, [element]: value.toLowerCase() } });
    }
  };

  handleCancel = () => this.setState({ visible: false });

  onFinish = async (e) => {
    if (e.remember === false) {
      notification["error"]({ message: "Warning.!", description: "Please accept our Terms and Conditions" });
      return;
    }
    if (!this.state.userProfile) {
      notification["error"]({ message: "Warning.!", description: "Please select the user type" });
      return;
    }
    this.setState({ loading: true });
    const lowerEmail = e.email.toLowerCase();
    try {
      await Auth.signUp(lowerEmail, e.password).then(data => {
        this.saveUser(data, lowerEmail);
        this.setState({
          loginPopupTrue:     false,
          visible:            true,
          signUpResponseData: data,
          email:              lowerEmail,
          password:           e.password,
          loading:            false,
        });
      });
    } catch (error) {
      message.error(error.message);
      this.setState({ visible: false, loading: false });
    }
  };

  handleOk = async (e) => {
    try {
      this.setState({ loading: true });
      await Auth.confirmSignUp(this.state.email, e.code).then(async () => {
        this.doLogin();
      });
    } catch (error) {
      this.setState({ loading: false });
      message.error("Invalid Confirm Code");
    }
  };

  doLogin = async () => {
    try {
      const user = await Auth.signIn(this.state.email, this.state.password);
      const userDetails = {
        token:  user.signInUserSession.idToken.jwtToken,
        userid: user.username,
      };
      this.props.context.setUser(userDetails, false);
      this.gotoApp(user.username);
    } catch (err) {
      message.error("Error: unable to login");
      this.setState({ loading: false, errors: err.message });
    }
  };

  saveUser = async (userKey, lowerEmail) => {
    const { userDetails, userProfile, referedByName, referedById, smsOptIn } = this.state;
    const checkBuyerProfile = await usersList("buyerProfileSignup");
    const buyerAgentInfo = (checkBuyerProfile?.data || []).find(
      b => b?.buyerEmail?.toLowerCase() === lowerEmail
    );
    const data = {
      entityData: {
        id:            userKey.userSub,
        firstName:     userDetails.firstName,
        lastName:      userDetails.lastName,
        phone:         userDetails.phone,
        email:         userDetails.email,
        userProfile:   userProfile,
        recordStatus:  true,
        mlsId:         userDetails.mlsId,
        referedByName: referedByName,
        referedById:   referedById,
        referredBy:    referedById,   // write both spellings for compatibility
        invitedBy:     referedById,
        smsOptIn:      smsOptIn,      // ← record SMS consent
        smsOptInDate:  smsOptIn ? new Date().toISOString() : null,
        agentInfo: {
          agentEmail: buyerAgentInfo?.agentEmail || "",
          agentName:  buyerAgentInfo?.agentName  || "",
        },
        addUserName: buyerAgentInfo?.agentName || "",
      },
    };
    noAuthadd(AppConfig["entityNames"]["users"], data).then(result => {
      if (result.success) {
        this.setState({ loading: false });
        message.success("User created successfully.");
      } else {
        this.setState({ loading: false });
        message.error(result.errors);
      }
    });
  };

  handleToRedirectPath = () => this.props.history.push("/homes");

  gotoApp = id => {
    getDetails(AppConfig["entityNames"]["users"], id).then(result => {
      if (result.success) {
        this.props.context.setUserDetails(result.data);
        localStorage.setItem("userDetails",    JSON.stringify(result.data));
        localStorage.setItem("userLogin",      JSON.stringify(true));
        localStorage.setItem("userLoginTime",  JSON.stringify(new Date().getTime()));

        const isAgentOrLender = ["AG", "L", "V"].includes(result.data.userProfile);
        if (isAgentOrLender && !result.data.profile_completed) {
          this.setState({ showProfileModal: true, loggedInUserData: result.data });
          return;
        }

        if (result.data.userProfile === "B") {
          this.props.goTopreviousPage ? window.location.reload() : this.props.history.push(`/viewProfile/${result.data.id}`);
        } else {
          this.props.goTopreviousPage ? window.location.reload() : this.props.history.push("/homes");
        }
      } else {
        message.error(result.errors);
        this.setState({ loading: false });
      }
    });
  };

  handleProfileComplete = () => {
    this.setState({ showProfileModal: false });
    const ud = this.state.loggedInUserData;
    if (this.props.goTopreviousPage) {
      window.location.reload();
    } else {
      this.props.history.push(ud?.id ? `/myProfile/${ud.id}` : "/myProfile");
    }
  };

  content = (
    <div>
      <p>- Minimum password length: 8</p>
      <p>- Required at least one uppercase letter</p>
      <p>- Required at least one lowercase letter</p>
      <p>- Required at least one number</p>
      <p>- Required at least one nonalphanumeric character</p>
    </div>
  );

  hanleLoginPopUp = () => {
    if (window.location.pathname === "/register") {
      this.props.history.push("/login");
    } else {
      if (!this.props.showLoginSiderForm && this.props.questionPage) {
        this.props.handleToshowLoginSider();
      } else {
        this.setState({ loginPopupTrue: true });
        this.props.closePreviouspopUp();
      }
    }
  };

  handleonCancel  = () => this.setState({ loginPopupTrue: false });
  onSelect        = (value, option) => this.setState({ referedById: option.value, referedByName: option.label });
  handleUserType  = option => this.setState({ userProfile: option });
  handleLoginForm = () => this.props.userHasAuthenticated(true);
  handleWithEmail = () => this.setState({ accountCreateWithEmail: true });

  signupForm = () => {
    const { smsOptIn } = this.state;
    return (
      <>
        <Row className="register" style={{ padding: "0.5%" }}>
          <Col xl={{ span: 18, offset: 5 }} lg={{ span: 18, offset: 5 }}
            md={{ span: 18, offset: 5 }} xs={{ span: 17, offset: 5 }} sm={{ span: 17, offset: 5 }}>
            <Button type="text" className="register-text" onClick={this.hanleLoginPopUp}>
              Already have an account? Login here
            </Button>
          </Col>
          {window.location.pathname === "/register" && (
            <Col xl={{ span: 1 }} lg={{ span: 1 }} md={{ span: 1 }} xs={{ span: 1 }} sm={{ span: 1 }} style={{ textAlign: "left" }}>
              <Link to="/"><CloseOutlined className="close-btn" /></Link>
            </Col>
          )}
        </Row>

        <Row>
          <Col xl={{ span: 24, offset: 0 }} lg={{ span: 24, offset: 0 }}
            md={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} xs={{ span: 24, offset: 0 }}
            className="mobile-view-display">
            <Link to="/"><img src={logo} alt="logo" className="logo-header-login" style={{ marginBottom: "0px" }} /></Link>
          </Col>
        </Row>

        <Row>
          <Col xl={{ span: 12, offset: 6 }} lg={{ span: 21, offset: 2 }}
            md={{ span: 21, offset: 2 }} sm={{ span: 22, offset: 1 }} xs={{ span: 22, offset: 1 }}>
            <div className="login-form-center">
              <h1 className="register-form-center-weight login-margin-top">Create an account</h1>
              <Row>
                <Col xxl={{ span: 12, offset: 0 }} xl={{ span: 24, offset: 0 }}
                  lg={{ span: 21, offset: 2 }} md={{ span: 21, offset: 2 }}
                  sm={{ span: 24, offset: 1 }} xs={{ span: 24, offset: 1 }}>
                  <SigninWithFacebook buttonText={"Sign Up"} handleToRedirectPath={this.handleToRedirectPath} getLoginData={this.gotoApp} />
                </Col>
                <Col xxl={{ span: 12, offset: 0 }} xl={{ span: 24, offset: 0 }}
                  lg={{ span: 21, offset: 2 }} md={{ span: 21, offset: 2 }}
                  sm={{ span: 24, offset: 1 }} xs={{ span: 24, offset: 1 }}>
                  <SigninWithGoogle buttonText={"Sign Up"} handleToRedirectPath={this.handleToRedirectPath} getLoginData={this.gotoApp} />
                </Col>
              </Row>
            </div>

            <Divider> or </Divider>

            <Form name="normal_login" className="login-form" initialValues={{ remember: true }} onFinish={this.onFinish}>
              <div className="register-form">

                {/* User type */}
                <Form.Item>
                  <Select style={{ width: "100%" }} placeholder="I am a..." onChange={this.handleUserType}>
                    <Option value="B">Buyer</Option>
                    <Option value="S">Seller</Option>
                    <Option value="AG">Agent</Option>
                    <Option value="L">Lender</Option>
                    <Option value="V">Vendor</Option>
                    <Option value="HO">Homeowner</Option>
                  </Select>
                </Form.Item>

                {/* Name */}
                <Form.Item name="username" rules={[{ required: true, message: "Please input your first name!" }]}>
                  <Input placeholder="First Name" value={this.state.userDetails.firstName}
                    onChange={e => this.handleOnChange("firstName", e.target.value)} className="form-input" />
                </Form.Item>
                <Form.Item name="username1" rules={[{ required: true, message: "Please input your last name!" }]}>
                  <Input placeholder="Last Name" value={this.state.userDetails.lastName}
                    onChange={e => this.handleOnChange("lastName", e.target.value)} className="form-input" />
                </Form.Item>

                {/* Phone + SMS opt-in */}
                <Form.Item name="phone" rules={[{ required: true, message: "Please input your phone number!" }]}>
                  <NumberFormat
                    className="ant-input-number"
                    placeholder="Phone Number"
                    value={this.state.userDetails.phone}
                    onChange={e => this.handleOnChange("phone", e.target.value)}
                    format="(###) ###-####"
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                {/* ── SMS consent ────────────────────────────────────────── */}
                <Form.Item style={{ marginTop: "-10px", marginBottom: "12px" }}>
                  <div style={{
                    background: "#f4f6ff", border: "1px solid #c5caf0",
                    borderRadius: "8px", padding: "10px 12px",
                  }}>
                    <Checkbox
                      checked={smsOptIn}
                      onChange={e => this.setState({ smsOptIn: e.target.checked })}
                      style={{ alignItems: "flex-start" }}
                    >
                      <span style={{ fontSize: "12px", color: "#444", lineHeight: 1.5 }}>
                        <strong>Optional:</strong> I consent to receive SMS verification codes
                        and account security alerts from My Home Buddha at the phone number
                        provided. Message &amp; data rates may apply. Reply <strong>STOP</strong> to
                        opt out at any time. Reply <strong>HELP</strong> for help. This number
                        will not be used for marketing messages.
                      </span>
                    </Checkbox>
                  </div>
                </Form.Item>
                {/* ─────────────────────────────────────────────────────────── */}

                {/* Email */}
                <Form.Item name="email" rules={[{ required: true, message: "Please input your e-mail!" }]}>
                  <Input type="email" placeholder="Email" value={this.state.userDetails.email}
                    onChange={e => this.handleOnChange("email", e.target.value)}
                    style={{ textTransform: "lowercase" }} className="form-input" />
                </Form.Item>

                {/* Password */}
                <Form.Item name="password" rules={[{ required: true, message: "Please input your password!" }]}>
                  <Input.Password placeholder="Password" value={this.state.userDetails.Password}
                    onChange={e => this.handleOnChange("password", e.target.value)} className="form-input" />
                </Form.Item>
                <Form.Item className="password-criteria">
                  <Popover content={this.content} title="Password Criteria">
                    <Button type="text" style={{ color: "#39acda", marginLeft: "-15px" }}>Password Criteria</Button>
                  </Popover>
                </Form.Item>

                {/* MLS ID — agents only */}
                {this.state.userProfile === "AG" && (
                  <Form.Item name="mlsId" rules={[{ required: true, message: "Please input your MLSID!" }]}>
                    <Input placeholder="MLSID" value={this.state.userDetails.mlsId}
                      onChange={e => this.handleOnChange("mlsId", e.target.value)}
                      style={{ width: "100%", textTransform: "uppercase" }} className="form-input" />
                  </Form.Item>
                )}

                {/* T&C checkbox */}
                <Form.Item name="remember" valuePropName="checked">
                  <Checkbox checked>
                    <span className="terms">I agree with </span>
                    <Button type="text" onClick={() => this.setState({ visibleTerms: true })}
                      style={{ color: "#39acda", marginLeft: "-15px" }}>
                      Terms &amp; Conditions
                    </Button>
                  </Checkbox>
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={this.state.loading} className="login-form-button">
                    Create an account
                  </Button>
                </Form.Item>
              </div>
            </Form>

            {/* Email confirmation modal */}
            {this.state.visible && (
              <Modal visible={this.state.visible}
                title={<p className="font-family-style font-medium-size" style={{ color: "blue", margin: "0px" }}>Confirm SignUp</p>}
                onCancel={this.handleCancel} maskClosable={false} className="modal-black-close" footer={null}>
                <div style={{ padding: "5px 10px" }}>
                  <span className="font-family-style text-size padding register-confirm">
                    We have sent you a confirmation code to your email. Please enter the code below to complete your signup.
                  </span>
                </div>
                <Form className="padding font-family-style text-size" onFinish={this.handleOk} style={{ padding: "5px 10px" }}>
                  <Form.Item name="code" rules={[{ required: true, message: "Please input the code." }]}>
                    <Input type="number" placeholder="Please input the code." className="form-input" maxLength="6" />
                  </Form.Item>
                  <Divider />
                  <Form.Item>
                    <Button type="primary" htmlType="submit" loading={this.state.loading}>
                      <span className="align">Submit</span>
                    </Button>
                  </Form.Item>
                </Form>
              </Modal>
            )}
          </Col>
        </Row>

        {/* ── Terms & Conditions drawer — updated with SMS section ──────── */}
        <Drawer
          title="Terms & Conditions"
          placement="bottom" height={"100%"} mask={true} closable={true}
          getContainer={false} visible={this.state.visibleTerms} onClose={this.onClose}
          headerStyle={{ textAlign: "center" }}
          bodyStyle={{ paddingBottom: 80, backgroundColor: "#eff2f5" }}
          style={{ position: "absolute" }}>
          <Row>
            <Col span={24} style={{ padding: "20px" }}>

              {/* Existing listing terms */}
              <Row>
                <p style={{ textAlign: "justify" }}>
                  I understand that by creating an account and adding property listings it will not mean it has been
                  listed in MLS and will only be listed on Home Buddha. I understand that as a consumer creating an
                  account and submitting listings on the network that this does not allow for the property to be
                  syndicated to thousands of search sites and it will only be listed on Home Buddha. I also understand
                  that in order to maximize exposure on my posted listings it may be in my best interests to consider
                  listing it on MLS with a Realtor or seek an entry-only service.
                </p>
              </Row>
              <Row>
                <p style={{ textAlign: "justify" }}>
                  As a licensed real estate agent/broker entering listings on this portal I understand that I am
                  subject to all MLS and Realtor board rules and regulations which may require me to list this property
                  in MLS. By entering listings on this site I am attesting that I am in full compliance with all
                  MLS &amp; Realtor board rules and regulations and have any required contracts in place at the time
                  of posting listings which may include but not limited to a listing contract, non-mls listing
                  agreement, delayed listing forms, etc.
                </p>
              </Row>
              <Row>
                <p style={{ textAlign: "justify" }}>
                  MyHomeBuddha.com will not be responsible for any violations by an agent or consumer due to false
                  advertising or lack of required contracts, disclosures, etc.
                </p>
              </Row>

              {/* ── NEW: SMS & Communications section ───────────────────── */}
              <Divider />
              <Row>
                <Col span={24}>
                  <h3 style={{ color: "#1A2280", fontWeight: 700, marginBottom: "12px" }}>
                    SMS &amp; Communications Consent
                  </h3>
                  <p style={{ textAlign: "justify" }}>
                    By providing your phone number and checking the SMS consent box during registration, you agree to
                    receive one-time passcodes (OTP) and account security alerts via SMS from My Home Buddha at the
                    phone number you provide. SMS verification is optional and used solely for account security
                    purposes such as two-factor authentication and phone number verification.
                  </p>
                  <p style={{ textAlign: "justify" }}>
                    <strong>Message frequency:</strong> Verification and security messages only — sent only when you
                    initiate an action requiring verification. No marketing or promotional messages will be sent to
                    this number.
                  </p>
                  <p style={{ textAlign: "justify" }}>
                    <strong>Message &amp; data rates may apply.</strong> To opt out of SMS messages at any time,
                    reply <strong>STOP</strong> to any message from us. To get help, reply <strong>HELP</strong>.
                    You may also remove your phone number or disable SMS verification at any time in your account
                    settings at myhomebuddha.com.
                  </p>
                  <p style={{ textAlign: "justify" }}>
                    For questions about our messaging practices, contact us at{" "}
                    <a href="mailto:info@myhomebuddha.com" style={{ color: "#1A2280" }}>info@myhomebuddha.com</a>.
                    For our full Privacy Policy visit{" "}
                    <a href="https://www.myhomebuddha.com/privacyPolicies" target="_blank" rel="noopener noreferrer" style={{ color: "#1A2280" }}>
                      myhomebuddha.com/privacyPolicies
                    </a>.
                  </p>
                </Col>
              </Row>
              {/* ─────────────────────────────────────────────────────────── */}

            </Col>
          </Row>
        </Drawer>
      </>
    );
  };

  render() {
    const { showAdd } = this.props;
    return (
      <div style={{ overflow: "hidden", backgroundColor: "#eff2f5" }}>
        {showAdd === false ? (
          <Row><Col xs={24}>{this.signupForm()}</Col></Row>
        ) : (
          <Row>
            <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
              <Login />
            </Col>
            <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
              {this.signupForm()}
            </Col>
          </Row>
        )}

        {this.state.showProfileModal && this.state.loggedInUserData && (
          <ProfileCompletionModal userDetails={this.state.loggedInUserData} onComplete={this.handleProfileComplete} />
        )}

        <SignupModal
          enableSignupForm={!this.props.comingFromDrawer && this.state.loginPopupTrue}
          handleonCancel={this.handleonCancel}
          showLoginPopup
          goTopreviousPage={this.props.goTopreviousPage}
        />
      </div>
    );
  }
}

export default withAppContext(withRouter(RegisterForm));
